import { RefObject } from 'react'

const PORTAL_CONTAINER_ATTRIBUTE = 'data-portal-container'

function createPortalContainer() {
  const portalContainer = document.createElement('div')

  portalContainer.setAttribute(PORTAL_CONTAINER_ATTRIBUTE, '')

  document.body.appendChild(portalContainer)

  return portalContainer
}

export const getDefaultPortalContainer = (): Element =>
  document.querySelector(`[${PORTAL_CONTAINER_ATTRIBUTE}]`) || createPortalContainer()

export function setRef<T>(
  ref: RefObject<T | null> | ((instance: T | null) => void) | null | undefined,
  value: T | null,
): void {
  if (typeof ref === 'function') {
    ref(value)
  } else if (ref) {
    ;(ref as { current: T | null }).current = value
  }
}
